import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('auth Gaurd server -', this.auth.isLoggedIn());
    if (this.auth.isLoggedIn()) return true;
    const fullUrl = window.location.href;
    if (window.location.href.indexOf('NewSignup') > 0) {
      this.router.navigate(['/registration/NewSignup']);
    }
    else {
      this.router.navigate(['/logins'], { queryParams: { returnUrl: state.url } });
    }
    return false;
  }

}

